<template>
  <div class='leak-keyword-table-cell'>
    <span class="value" :title='value'>{{ value }}</span>
  </div>
</template>

<script>
export default {
  name: 'LeakKeywordTableCell',
  props: {
    item: {
      type: Object,
      required: true,
    },
    column: {
      type: Object,
      required: true,
    },
  },
  computed: {
    value() {
      return this.item[this.column.field];
    },
  },
};
</script>

<style lang="scss">
.leak-keyword-table-cell {
  .value {
    z-index: 2;
    max-width: 200px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
</style>
